import { Directive, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SignatureDrawerBase } from './signature-drawer.base';

@Directive({
  selector: '[redSignatureDrawer]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignatureDrawerDirective),
      multi: true,
    },
  ],
})
export class SignatureDrawerDirective extends SignatureDrawerBase {}
